module.exports = __webpack_public_path__ + "img/tv-apps-w.svg";